import { render, staticRenderFns } from "./VectorDetail.vue?vue&type=template&id=6a0938ba&scoped=true"
import script from "./VectorDetail.vue?vue&type=script&lang=js"
export * from "./VectorDetail.vue?vue&type=script&lang=js"
import style0 from "./VectorDetail.vue?vue&type=style&index=0&id=6a0938ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0938ba",
  null
  
)

export default component.exports